import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";

const DeleteVideo = (props) => {
    // const submit = props.submit
    const getData = props.getData
    const modal3 = props.modal3
    const setModal3 = props.setModal3
    // const deleteArray2 = props.deleteArray2
    const id = props.currentID

    // const id = props.id

    const cancelDelete = (e) => {
        e.preventDefault();
        setModal3(!modal3)
    }

    const deleteVideo = async (e) => {
        e.preventDefault();

        
        console.log("deleting the individual video or multiple")
        axios.delete(`/api/videos`,  { data: { ids: [id] }, 
          headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
          },
        })
          .then(response => {
            console.log(response)
            showSuccessToast(response.data && response.data.Message.substring(0,15) ? response.data.Message : "Success")
            console.log(response.data.Message)
            getData()
            setModal3(false)
          })
          .catch(error => {
            // Handle error
            // console.error(error);
            showErrorToast( "Failed")
          });
      }



    return (
        <div>
            <Modal size="md" isOpen={modal3} toggle={() => setModal3(!modal3)}>
                <ModalHeader toggle={() => setModal3(!modal3)}>
                    Delete Videos
                </ModalHeader>
                <ModalBody>
                    <form >
                    <div className="d-flex justify-content-center">
                            Are you sure you want to delete?
                        </div>
                        <div className="d-flex justify-content-center">
                            <button
                                type="submit"
                                className="btn btn-secondary m-4"
                                onClick={(e) => cancelDelete(e)}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary m-4"
                                onClick={(id) => deleteVideo(id)}
                            >
                                Delete
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default DeleteVideo;
